import React from "react";
import RecipeCard2 from "./RecipeCard2";

export default function RecipesList({ recipes }) {
  return (
    <div className="recipeslist">
      <div className="recipeslist-center">
        {recipes.map((recipe) => {
          return (
            <RecipeCard2
              key={recipe.id}
              recipe={recipe}
              dishTypes={
                recipe.dishTypes.length ? recipe.dishTypes : recipe.diets
              }
            />
          );
        })}
      </div>
    </div>
  );
}
